<template>
  <section>
    <v-layout row justify-center pb-4>
      <v-flex xs6 md6 pl-2>
        <v-hover>
          <v-card
            @click="showEditMessageDialog = true"
            v-ripple
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 8 : 2}`"
          >
            <v-card-title primary-title class="headline grey lighten-2">
              <v-icon medium left>notifications</v-icon>
              <span class="title font-weight-light">{{message.prettyName}}</span>
            </v-card-title>
            <!-- A bit ugly atm but functional -->
            <v-flex pt-1>
              <v-card-text>
                <v-icon left>title</v-icon>
                {{messageTitle}}
              </v-card-text>
            </v-flex>
            <v-divider />
            <v-card-text>
              <v-icon left>message</v-icon>
              {{messageBody}}
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs6 md6 pl-5>
        <v-layout row justify-left>
          <EnableMessageSwitch
            :messageKey="this.message.name"
            :enabled="this.message.enabled"
            currentType="push"
          />
        </v-layout>
        <v-layout row justify-left>
          <v-flex xs6 md6>
            <v-layout row>
              <v-flex shrink pr-2>
                <EditPushMessage
                  :messageKey="message.name"
                  :messagePrettyName="message.prettyName"
                  :messageTitle="message.title"
                  :messageBody="messageBody"
                  :messageDescription="message.description"
                  :messageFields="message.fields"
                  :prettyFields="prettyFields"
                  :showEditMessageDialog="showEditMessageDialog"
                  v-on:editDialogClosed="showEditMessageDialog = false"
                  v-on:updatedMessage="updateMessageCard"
                />
              </v-flex>
              <TestMessage
                :messageKey="message.name"
                :messagePrettyName="message.prettyName"
                messageType="push"
              />
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import EditPushMessage from "@/components/settings/messages_emails/EditPushMessage.vue";
import EnableMessageSwitch from "@/components/settings/messages_emails/EnableMessageSwitch.vue";
import TestMessage from "@/components/settings/messages_emails/TestMessage.vue";

export default {
  name: "push_message_item",
  components: {
    EnableMessageSwitch,
    EditPushMessage,
    TestMessage
  },
  props: {
    message: Object,
    prettyFields: Object
  },
  data: function() {
    return {
      messageTitle: null,
      messageBody: null,
      showEditMessageDialog: false
    };
  },
  methods: {
    updateMessageCard: function(newValue) {
      this.messageTitle = newValue.title;
      this.messageBody = newValue.body;
    }
  },
  beforeMount: function() {
    this.messageTitle = this.message.title;
    this.messageBody = this.message.body;
  }
};
</script>